import { render, staticRenderFns } from "./LPR.vue?vue&type=template&id=0b7f04da"
import script from "./LPR.vue?vue&type=script&lang=js"
export * from "./LPR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports